// src/env.js

// Hàm đọc env runtime (window._env_) hoặc build-time (process.env)
export const getEnv = (key, defaultValue) => {
  if (typeof window !== "undefined" && window._env_ && window._env_[key] !== undefined) {
    return window._env_[key];
  }
  if (process.env[key] !== undefined) {
    return process.env[key];
  }
  return defaultValue;
};

export const getBooleanEnv = (key, defaultValue = false) => {
  const value = getEnv(key);
  if (value === undefined) return defaultValue;
  return value === "true" || value === true;
};

export const getNumberEnv = (key, defaultValue) => {
  const value = getEnv(key);
  return value !== undefined ? Number(value) : defaultValue;
};

export const getListEnv = (key, defaultValue = []) => {
  const value = getEnv(key);
  return value ? String(value).split(",") : defaultValue;
};

// Tiện ích riêng cho API Base URL
export const getApiBaseUrl = (defaultValue) => {
  return getEnv("REACT_APP_API_BASE_URL", defaultValue);
};
